import { useContext } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import ListGroup from "react-bootstrap/ListGroup";
// import FormCheck from "react-bootstrap/FormCheck";
// import ButtonGroup from "react-bootstrap/ButtonGroup";
// import ToggleButton from "react-bootstrap/ToggleButton";

import Header from "components/Header";

import { AuthContext } from "lib/context/auth";

function useAuth() {
  return useContext(AuthContext);
}

export default function Settings() {
  const auth = useAuth();
  const darkMode = auth?.darkMode ?? false;
  const variant = darkMode ? "dark" : undefined;

  // const [autoColorScheme, setAutoColorScheme] = useState(
  //   localStorage.getItem("colorScheme") === "auto" || false
  // );

  return (
    <div id="Settings">
      <Header />
      <Container fluid>
        <Row className="mt-3">
          <Col lg={6}>
            <h3>Settings</h3>
            {/* <ListGroup className="mt-3">
              <ListGroupItem action variant={variant}><b>Display Settings</b></ListGroupItem>
              <ListGroupItem action variant={variant}>
                <Row className="d-flex">
                  <Col xs={12} className="d-flex align-items-center pt-2">
                    <ButtonGroup>
                      <ToggleButton
                        id="auto-dark-mode"
                        type="radio"
                        variant="outline-primary"
                        name="radio"
                        value="auto"
                        checked={autoColorScheme}
                        onChange={() => {
                          setAutoColorScheme(true);
                          window.localStorage.setItem("colorScheme", "auto");
                          window.matchMedia("(prefers-color-scheme: dark)").matches
                            ? auth?.setDarkMode(true)
                            : auth?.setDarkMode(false);
                        }}
                      >
                        Auto-detect
                      </ToggleButton>
                      <ToggleButton
                        id="manual-dark-mode"
                        type="radio"
                        variant="outline-primary"
                        name="radio"
                        value="manual"
                        checked={!autoColorScheme}
                        onChange={() => {setAutoColorScheme(false); window.localStorage.setItem("colorScheme", "light"); auth?.setDarkMode(false);}}
                      >
                        Manual
                      </ToggleButton>
                    </ButtonGroup>
                  </Col>        
                  <Col xs={12} className="pt-2">
                    { !autoColorScheme
                      && <FormCheck
                        type="switch"
                        id="dark-mode-switch"
                        label={`Dark mode ${darkMode ? "on" : "off"}`}
                        checked={darkMode}
                        onChange={() => {auth?.setDarkMode(!darkMode); window.localStorage.setItem("colorScheme", !darkMode ? "dark" : "light");}}
                      />
                    }
                  </Col>      
                </Row>
              </ListGroupItem>
            </ListGroup> */}
            <ListGroup className="mt-3">
              <ListGroupItem variant={variant}><b>User Information:</b></ListGroupItem>
              <ListGroupItem variant={variant}><b>Name:</b> {auth?.user?.given_name}</ListGroupItem>
              <ListGroupItem variant={variant}><b>Email:</b> {auth?.user?.email}</ListGroupItem>
              <ListGroupItem variant={variant}><b>Roles:</b> 
                <ul>
                  {
                    auth?.user?.roles.map((role) => {
                      return <li key={role}>{role}</li>;
                    })
                  }
                </ul>
              </ListGroupItem>
            </ListGroup>
            <ListGroup className="mt-3">
              <ListGroupItem variant={variant}><b>System Information:</b></ListGroupItem>
              <ListGroupItem variant={variant}><b>EVOS Monitoring App version:</b> {process.env.REACT_APP_VERSION ?? "Unknown"}</ListGroupItem>
              <ListGroupItem variant={variant}><b>Timezone:</b> {Intl.DateTimeFormat().resolvedOptions().timeZone ?? "Unknown"}</ListGroupItem>
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
}